export const DO_NOT_PREPARE = 'doNotPrepare';
export const DO_NOT_TRANSMIT = 'doNotTransmit';
export const DO_NOT_PRODUCE = 'doNotProduce';
export const DO_NOT_SHIP = 'doNotShip';
export const SHIP = 'ship';
